import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getEmailTemplateSettings = (emailTemplateId) => {
    return vdkEmHappinessPortalApi.get(`/email-templates/${emailTemplateId}/settings`);
};
const createEmailTemplateSettings = (request) => {
    return vdkEmHappinessPortalApi.post(`/email-templates/${request.emailTemplateId}/settings`, request);
};
const updateEmailTemplateSettings = (request) => {
    return vdkEmHappinessPortalApi.put(`/email-templates-settings/${request.emailTemplateId}`, request);
};
const cancelEmailTemplateSettings = (request) => {
    return vdkEmHappinessPortalApi.put(`/email-templates/${request.emailTemplateId}/settings/${request.settingsId}/cancel`, {});
};
const sendEmailTemplate = (request) => {
    return vdkEmHappinessPortalApi.post(`/email-templates/${request.emailTemplateId}/send`, {});
};
const getEmailTemplateScheduledStatus = (eventId) => {
    return vdkEmHappinessPortalApi.get(`/events/${eventId}/email-templates/scheduled-status`);
};
const EmailTemplateSettingsApi = {
    getEmailTemplateSettings,
    createEmailTemplateSettings,
    updateEmailTemplateSettings,
    cancelEmailTemplateSettings,
    sendEmailTemplate,
    getEmailTemplateScheduledStatus
};
export default EmailTemplateSettingsApi;
